namespace $.$$ {
	
	export class $shm_hitalama_entity_catalog extends $.$shm_hitalama_entity_catalog {

		spread_pages_deep() {
			const spread = this.spread_current()
			return spread
				? spread instanceof $mol_book2
					? spread.pages_deep()
					: [ spread ]
				: []
		}

		@ $mol_mem
		pages(): any[] {
			try {
				return [
					this.Menu(),
					...this.spread_pages_deep(),
				]
			} catch (error) {
				const message = $mol_promise_like(error) ? 'Loading...' : String( error )
				return [
					this.Menu(),
					message,
				]
			}
		}

		@ $mol_mem
		list() {
			return null as any as InstanceType< ReturnType< typeof $giper_baza_list_link.to > >
		}

		@ $mol_action
		add() {
			const entity = this.list()?.make( [[ null, $giper_baza_rank_read ]] ) as any
			entity?.title( this.title_default() )
			this.spread( entity.link().toString() )
			return entity
		}

		@ $mol_action
		cut( id: string ) {
			this.list()?.cut( new $giper_baza_link( id ) )
		}

		@ $mol_mem_key
		entity( id: string ) {
			return $giper_baza_glob.Pawn( new $giper_baza_link( id ), $giper_baza_entity )
		}

		@ $mol_mem
		entities(): readonly $giper_baza_entity[] {
			return this.list().remote_list() as readonly $giper_baza_entity[]
		}

		@ $mol_mem
		spreads() {
			return this.$.$mol_error_fence(
				()=> Object.fromEntries( this.entities().map( entity => [
					entity.link().toString(),
					this.Page( entity.link().toString() ),
				] ) ),
				()=> ({}),
				()=> ({}),
			)
		}
		
		@ $mol_mem
		override spread( next?: string ) {
			const arg = this.$.$mol_state_arg.value( this.param(), next ) ?? undefined
			return this.$.$mol_state_arg.value( this.param(),
				this.$.$mol_state_session.value( this.toString() + '.spread', arg ) 
			) ?? ''
		}

	}

}
